import isAfter from 'date-fns/isAfter';
import { logger } from 'lib/logger';
import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import type { Product } from 'reactApp/types/Billing';
import { addPeriodToDate } from 'reactApp/utils/Period';
import { captureException } from 'reactApp/utils/tracer';

/**
 * @warning Метод не гарантирует точный результат, если были частичные списания.
 *
 * @description Проверяем было ли ожидаемое количество оплат или более.
 * При подсчетах исключается trial период, учитываются только discount и regular платежи.
 *
 * @param subscription - подписка
 * @param product - продукт
 * @param times - ожидаемое минимальное число продлений
 */
export const checkSubscriptionRenewedTimes = (
    { start, expires }: BillingDataSubscriptionInfo,
    { period, trialPeriod, hasTrial, hasDiscount, discountPeriod, discountPeriodCount = 1 }: Product,
    times: number
) => {
    const periodsToAdd: string[] = [];
    let normalizedTimes = times;
    if (hasTrial && trialPeriod) {
        periodsToAdd.push(trialPeriod);
        normalizedTimes += 1;
    }

    if (hasDiscount && discountPeriod) {
        const discountPeriods = new Array(discountPeriodCount).fill(discountPeriod);
        periodsToAdd.push(...discountPeriods);
    }

    const regularPeriodsCount = normalizedTimes - periodsToAdd.length;
    if (regularPeriodsCount > 0) {
        const regularPeriods = new Array(regularPeriodsCount).fill(period);
        periodsToAdd.push(...regularPeriods);
    }

    const targetPeriods = periodsToAdd.slice(0, normalizedTimes);
    const supposedEndPeriod = targetPeriods.reduce((prev, current) => addPeriodToDate(prev, current), start);

    return !isAfter(supposedEndPeriod, expires);
};

export function logError(error: unknown) {
    logger.error(error);
    captureException(error, { issueKey: 'subs renewal error' });
}
